export const supportedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

export enum PlatformType {
  Instagram = 'Instagram',
  TikTok = 'TikTok',
  Facebook = 'Facebook',
  YouTube = 'YouTube',
  XHS = 'XHS',
  Lemon8 = 'Lemon8',
  X = 'X',
}

export const postFormats: Record<PlatformType, string[]> = {
  Instagram: ['Photo', 'Reels', 'Multipost', 'Story'],
  TikTok: ['Video', 'Multipost', 'Story'],
  Facebook: ['Photo', 'Video', 'Multipost', 'Story'],
  YouTube: ['Video', 'Shorts'],
  XHS: ['Video', 'Multipost'],
  Lemon8: ['Video', 'Multipost'],
  X: ['Photo', 'Video', 'Story'],
};

export const maximumFilesAllowed = 10;

export const screenshotNames = [
  'FacebookPhoto.jpeg',
  'FacebookStory.jpeg',
  'FacebookEngagementVideo.jpeg',
  'FacebookReachVideo.jpeg',
  'FacebookMultipost.jpeg',
  'InstagramReachMultipost.jpeg',
  'InstagramEngagementMultipost.jpeg',
  'InstagramReachPhoto.jpeg',
  'InstagramEngagementPhoto.jpeg',
  'InstagramReachReels.jpeg',
  'InstagramEngagementReels.jpeg',
  'InstagramReachStory.jpeg',
  'InstagramEngagementStory.jpeg',
  'Lemon8EngagementMultipost.jpeg',
  'Lemon8EngagementVideo.jpeg',
  'Lemon8ReachMultipost.jpeg',
  'Lemon8ReachVideo.jpeg',
  'TikTokReachMultipost.jpeg',
  'TikTokEngagementMultipost.jpeg',
  'TikTokStory.jpeg',
  'TikTokEngagementVideo.jpeg',
  'TikTokReachVideo.jpeg',
  'XHSReachVideo.jpeg',
  'XHSReachMultipost.jpeg',
  'XHSEngagementVideo.jpeg',
  'XHSEngagementMultipost.jpeg',
  'YouTubeShorts.jpeg',
  'YouTubeVideo.jpeg',
];
